import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "plus-sign" }, null, -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = {
  key: 0,
  class: "btn btn--fullscreen",
  type: "submit"
}

import FormRow from "@/components/forms/FormRow.vue";
import Fieldset from "@/components/forms/Fieldset.vue";
import FormInput from "@/components/forms/FormInput.vue";
import FormCheckbox from "@/components/forms/FormCheckbox.vue";
import FormErrorsList from "@/components/forms/FormErrorsList.vue";
import { ref, watch } from "vue";
import { useI18n } from "vue3-i18n";
import { notifyError, notifySuccess } from "@/notify";
import { useActivityOccurrenceService } from "@/inversify.config";
import { Status } from "@/validation";
import {Participant} from "@/types/entities/activity";
import {SucceededOrNotResponse} from "@/types/responses";

interface propsInterface {
  isOnlineActivity: boolean,
  activityOccurrenceId: string,
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'NewActivityParticipant',
  props: {
    isOnlineActivity: { type: Boolean },
    activityOccurrenceId: {}
  },
  emits: ["newParticipantAdded"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const activityOccurrenceService = useActivityOccurrenceService();

// eslint-disable-next-line
const props = __props;

const emit = __emit;

const isOnline = ref<boolean>(props.isOnlineActivity);
const activityOccurrenceId = ref(props.activityOccurrenceId);

let newParticipant = ref<Participant>(new Participant);
const showAddParticipantPlusButton = ref<boolean>(true);

watch(props, (newProps) => {
  isOnline.value = newProps.isOnlineActivity;
  activityOccurrenceId.value = newProps.activityOccurrenceId;
});

watch(activityOccurrenceId, () => showAddParticipantPlusButton.value = true);

const formInputs = ref<(typeof FormInput)[]>([])
const inputValidationStatuses:any = {}

function addFormInputRef(ref: typeof FormInput) {
    if (!formInputs.value.includes(ref) && ref != null)
        formInputs.value.push(ref)
}

async function handleValidation(name: string, validationStatus: Status) {
    inputValidationStatuses[name] = validationStatus.valid
}

async function handleSubmit() {
  formInputs.value.forEach((x: typeof FormInput) => x.validateInput())
  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }
  else {
    await addParticipant();
  }
}

async function addParticipant() {
  errorsMessages.value = []
  let response = await activityOccurrenceService.addParticipantToActivityOccurrence(activityOccurrenceId.value, newParticipant.value)
  if (!response.id) {
    notifyError(t('participants.saveError'))
    displayErrors(response as SucceededOrNotResponse)
    return
  }
  notifySuccess(t('participants.saveSuccess'))
  emit("newParticipantAdded")
  showAddParticipantPlusButton.value = !showAddParticipantPlusButton.value
  newParticipant.value = new Participant();
}

const errorsMessages = ref<string[]>([])
function displayErrors(response: SucceededOrNotResponse) {
  response = new SucceededOrNotResponse(response.succeeded, response.errors)
  if (response?.succeeded != undefined && !response?.succeeded) {
    errorsMessages.value = response.getErrorMessages('validation.participants')
  }
  else errorsMessages.value = []
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (showAddParticipantPlusButton.value && props.activityOccurrenceId)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn--border util--ml-auto",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddParticipantPlusButton.value = !showAddParticipantPlusButton.value))
        }, [
          _createTextVNode(_toDisplayString(_unref(t)("participants.add")) + " ", 1),
          _hoisted_1
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "form",
      novalidate: "",
      onSubmit: _withModifiers(handleSubmit, ["prevent"]),
      enctype: "multipart/form-data"
    }, [
      (errorsMessages.value.length)
        ? (_openBlock(), _createBlock(FormErrorsList, {
            key: 0,
            title: _unref(t)('global.formErrorNotification'),
            errorsList: errorsMessages.value
          }, null, 8, ["title", "errorsList"]))
        : _createCommentVNode("", true),
      (!showAddParticipantPlusButton.value)
        ? (_openBlock(), _createBlock(Fieldset, {
            key: 1,
            title: _unref(t)('participants.newParticipant')
          }, {
            default: _withCtx(() => [
              _createVNode(FormRow, null, {
                default: _withCtx(() => [
                  _createVNode(FormInput, {
                    ref: addFormInputRef,
                    modelValue: _unref(newParticipant).firstName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(newParticipant).firstName) = $event)),
                    name: "newParticipantFirstName",
                    type: "text",
                    label: _unref(t)('participants.firstName'),
                    onValidated: handleValidation
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(FormInput, {
                    ref: addFormInputRef,
                    modelValue: _unref(newParticipant).lastName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(newParticipant).lastName) = $event)),
                    name: "newParticipantLastName",
                    type: "text",
                    label: _unref(t)('participants.lastName'),
                    onValidated: handleValidation
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              }),
              _createVNode(FormRow, null, {
                default: _withCtx(() => [
                  _createVNode(FormInput, {
                    ref: addFormInputRef,
                    modelValue: _unref(newParticipant).emailAddress,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(newParticipant).emailAddress) = $event)),
                    name: "newParticipantEmailAddress",
                    type: "text",
                    label: _unref(t)('participants.email'),
                    onValidated: handleValidation
                  }, null, 8, ["modelValue", "label"]),
                  (!isOnline.value)
                    ? (_openBlock(), _createBlock(FormInput, {
                        key: 0,
                        modelValue: _unref(newParticipant).allergies,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(newParticipant).allergies) = $event)),
                        name: "newParticipantAllergies",
                        type: "text",
                        rules: [],
                        label: _unref(t)('participants.allergies')
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(FormRow, null, {
                default: _withCtx(() => [
                  (!isOnline.value)
                    ? (_openBlock(), _createBlock(FormCheckbox, {
                        key: 0,
                        modelValue: _unref(newParticipant).reducedMobility,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(newParticipant).reducedMobility) = $event)),
                        name: "reducedMobility",
                        label: _unref(t)('participants.reducedMobility')
                      }, null, 8, ["modelValue", "label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (!showAddParticipantPlusButton.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_3, _toDisplayString(_unref(t)('global.add')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2)
  ]))
}
}

})